module.exports = __webpack_public_path__ + "img/z-icon-logo.d81e9af8.png";